import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseHomeLanding() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("لطفا اطلاعات لندینگ را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validateItem(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("لطفا اطلاعات آیتم را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetHomeLandings = (landingID, callback) => {
    MyAxios.get(`Admin_HomeLanding`, {
      headers: {
        AID: landingID,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetLandingByID = (landingID, callback) => {
    MyAxios.get(`Admin_HomeLanding/${landingID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addLandingBox = (state, file1, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file1) {
      data.append("Image1", file1);
    }
    MyAxios.post(`Admin_HomeLanding`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("لندینگ با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const updateLandingBox = (state, file1, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file1) {
      data.append("Image1", file1);
    }
    MyAxios.put(`Admin_HomeLanding`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("لندینگ با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteLandingBox = (LandID, callback) => {
    const data = new FormData();
    data.append("LandID", LandID);
    MyAxios.delete(`Admin_HomeLanding`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("لندینگ با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  const addLandingItem = (state, Image, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Image) {
      data.append("Image", Image);
    }
    MyAxios.post(`Admin_HomeLanding/Item`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آیتم با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const updateLandingItem = (state, file1, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file1) {
      data.append("Image1", file1);
    }
    MyAxios.put(`Admin_HomeLanding/Item`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آیتم با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteLandingItem = (LandItemID, callback) => {
    const data = new FormData();
    data.append("LandItemID", LandItemID);
    MyAxios.delete(`Admin_HomeLanding/Item`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("آیتم با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    validate,
    validateItem,
    GetHomeLandings,
    GetLandingByID,
    addLandingBox,
    updateLandingBox,
    deleteLandingBox,
    addLandingItem,
    updateLandingItem,
    deleteLandingItem,
  };
}
